import React, { Component } from 'react';

import get from 'utils/get';

import IntroVideo from 'components/IntroVideo';
import EntranceOption from 'components/EntranceOption';
import withMeta from 'lib/withMeta';

class LandingView extends Component {
  render() {
    const {
      actions: { removeAllCategories },
      model,
      globalSettings
    } = this.props;

    if (model.isError) return <h1>Error</h1>;

    const entranceOption1Video = get(
      globalSettings,
      'entranceOption1Video',
      {}
    );
    const entranceOption2Video = get(
      globalSettings,
      'entranceOption2Video',
      {}
    );
    const entranceOption3Video = get(
      globalSettings,
      'entranceOption3Video',
      {}
    );
    const introVideo = get(globalSettings, 'introVideo', {});

    return (
      <div className="relative">
        {!!get(introVideo, 'url', '') && <IntroVideo video={introVideo} />}
        <EntranceOption
          removeAllCategories={removeAllCategories}
          entranceOption1Video={entranceOption1Video}
          entranceOption2Video={entranceOption2Video}
          entranceOption3Video={entranceOption3Video}
        />
      </div>
    );
  }
}

export default withMeta(LandingView, 'globalSettings');
